import { NgModule } from '@angular/core';
import { DataSourceTransformPipe } from './data-source-transform.pipe';
import { DiagnosisDescriptionByCodePipe } from './diagnosis-description-by-code.pipe';
import { FilterByFilteredCriteriaPipe } from './filter-by-filtered-criteria.pipe';
import { GetStatusCommentPipe } from './get-status-comment.pipe';
import { GetUserProfileCredentialsByEmailPipe } from './get-user-profile-credentials-by-email.pipe';
import { LookupPipe } from './lookup.pipe';
import { MenuColorClassPipe } from './menu-color-class.pipe';
import { PhoneNumberPipe } from './phone-number.pipe';
import { PluralizePipe } from './pluralize.pipe';
import { SafeHtmlPipe } from './safeHtml.pipe';
import { SkillCodePipe } from './skill-code.pipe';
import { ZipCodePipe } from './zip-code.pipe';
import { UserCredentialsInternalPipe } from './user-credentials-internal.pipe';
import { TruncateTextPipe } from './truncate-text.pipe';
import { ElapsedTimePipe } from './elapsed-time.pipe';

const PIPES = [
  GetStatusCommentPipe,
  LookupPipe,
  SafeHtmlPipe,
  MenuColorClassPipe,
  PhoneNumberPipe,
  FilterByFilteredCriteriaPipe,
  GetUserProfileCredentialsByEmailPipe,
  DiagnosisDescriptionByCodePipe,
  PluralizePipe,
  SkillCodePipe,
  DataSourceTransformPipe,
  ZipCodePipe,
  UserCredentialsInternalPipe,
  TruncateTextPipe,
  ElapsedTimePipe
];

@NgModule({
  declarations: [...PIPES],
  exports: [...PIPES],
  providers: [...PIPES],
})
export class PipeModule {}
